import { Spinner } from '@iwoca/orion';

import styles from './RouteSpinner.module.css';

const RouteSpinner = () => {
  return (
    <div
      className={styles.signupSpinnerContainer}
      role="status"
      aria-label="Loading"
    >
      <Spinner className={styles.pageSpinner} />
    </div>
  );
};

export default RouteSpinner;
